import axiosInstance from "../scenes/utils/axiosInstance";
import { API_ENDPOINTS } from "../config/api";

class NotificationService {
  list = async ({ limit = 30, unreadOnly = false } = {}) => {
    const params = { limit, pageIndex: 0, sortBy: "created_at", sortOrder: "DESC" };
    if (unreadOnly) params.unread = "true";
    const res = await axiosInstance.get(API_ENDPOINTS.NOTIFICATIONS.LIST, { params });
    return res.data;
  };

  getStats = async () => {
    const res = await axiosInstance.get(API_ENDPOINTS.NOTIFICATIONS.STATS);
    return res.data;
  };

  markRead = async (id) => {
    const res = await axiosInstance.patch(API_ENDPOINTS.NOTIFICATIONS.READ(id));
    return res.data;
  };

  markAllRead = async () => {
    const res = await axiosInstance.post(API_ENDPOINTS.NOTIFICATIONS.READ_ALL);
    return res.data;
  };

  deleteOne = async (id) => {
    const res = await axiosInstance.delete(API_ENDPOINTS.NOTIFICATIONS.DELETE(id));
    return res.data;
  };

  deleteAll = async () => {
    const res = await axiosInstance.delete(API_ENDPOINTS.NOTIFICATIONS.DELETE_ALL);
    return res.data;
  };
}

export default NotificationService;
